<template>
    <div class="transformerView">
        <div class="title">基本信息</div>
        <div class="overview">
            <div class="message">
                <h1>{{transformer.deviceName}}</h1>
                <p>类型：{{transformer.device_type_name}}</p>
                <p>型号：{{transformer.device_model_name}}</p>
                <p>品牌：{{transformer.device_brand_name}}</p>
                <p>站点：{{transformer.areaName}}</p>
            </div>
            <div class="load">
                <SemicircleProgressBar :options="options" :value="transformerLoad == '--'?0:transformerLoad / 100"/>
                <div class="valNumber">
                    <p :class="transformerLoad == '--'? 'grey':''">{{ transformerLoad == '--'?'--':transformerLoad + '%'}}</p>
                    <p>负载率</p>
                </div>
            </div>
            <div class="loadcap">
                <div class="realtime">
                    <p>实时负载</p>
                    <p :class="mqttval(transformer.subLoopUrl + '/P') == '--'? 'grey':''">{{ mqttval(transformer.subLoopUrl + '/P') == '--'?'--': Number(Number(mqttval(transformer.subLoopUrl + '/P')) / 1000).toFixed(3)}} <span v-show="mqttval(transformer.subLoopUrl + '/P') !== '--'">kW</span></p>
                </div>
                <div class="realtime">
                    <p>额定容量</p>
                    <p >{{parseInt(JSON.parse(transformer.device_details)['电气']['容量'])}} <span>kVA</span></p>
                </div>
            </div>
        </div>
        <div class="transformerEnty">
            <div class="heightLow heightLow1">
                <div class="tab">
                    <span class="se">高压侧</span>
                </div>
                <div class="box">
                    <div class="boxItem" v-for="item in heightArr" :key="item.id">
                        <div class="val"><span>{{item.con}}</span></div>
                        <div :class="mqttval(hvsLoop + item.value) == '--'? 'val grey':'val'"><span>{{mqttval(hvsLoop + item.value) }}<i v-show="mqttval(hvsLoop + item.value) !== '--'">{{ item.unit}}</i></span></div>
                    </div>
                </div>
            </div>
            <div class="enty">
                <div class="temperature">
                    <div class="temItem">
                        <span></span>
                        <span>A相：</span>
                        <span :class=" mqttval(transformer.subLoopUrl + '/Temperature_A') == '--'? 'grey':''">{{ mqttval(transformer.subLoopUrl + '/Temperature_A') == '--'?'--': Number(mqttval(transformer.subLoopUrl + '/Temperature_A')).toFixed(0)}} <i v-show="mqttval(transformer.subLoopUrl + '/Temperature_A') !== '--'">℃</i></span>
                    </div>
                    <div class="temItem">
                        <span></span>
                        <span>B相：</span>
                        <span :class=" mqttval(transformer.subLoopUrl + '/Temperature_B') == '--'? 'grey':''">{{ mqttval(transformer.subLoopUrl + '/Temperature_B') == '--'?'--': Number(mqttval(transformer.subLoopUrl + '/Temperature_B')).toFixed(0)}} <i v-show="mqttval(transformer.subLoopUrl + '/Temperature_B') !== '--'">℃</i></span>
                    </div>
                    <div class="temItem">
                        <span></span>
                        <span>C相：</span>
                        <span :class=" mqttval(transformer.subLoopUrl + '/Temperature_C') == '--'? 'grey':''">{{ mqttval(transformer.subLoopUrl + '/Temperature_C') == '--'?'--': Number(mqttval(transformer.subLoopUrl + '/Temperature_C')).toFixed(0)}} <i v-show="mqttval(transformer.subLoopUrl + '/Temperature_C') !== '--'">℃</i></span>
                    </div>
                </div>
                <div class="fan">
                    <img :class="{'transtion':mqttval(transformer.subLoopUrl + '/Fan_Status') == '--'?false: Number(mqttval(transformer.subLoopUrl + '/Fan_Status'))}" src="../../../assets/img/fan.png" alt="">
                    <div class="status">风机状态：<span>{{Number(mqttval(transformer.subLoopUrl + '/Fan_Status')) == 1?'开启': Number(mqttval(transformer.subLoopUrl + '/Fan_Status')) == 0?'关闭':'--'}}</span></div>
                </div>
            </div>
            <div class="heightLow">
                <div class="tab">
                    <span class="se" >低压侧</span>
                </div>
                <div class="box">
                    <div class="boxItem" v-for="item in lowArr" :key="item.id">
                        <div class="val"><span>{{item.con}}</span></div>
                        <div :class=" mqttval(lvsLoop + item.value) == '--'? 'val grey':'val'"><span>{{mqttval(lvsLoop + item.value) == '--'?'--': (mqttval(lvsLoop + item.value) / item.multiple).toFixed(2) }}<i v-show="mqttval(lvsLoop + item.value) !== '--'">{{ item.unit1}}</i></span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const SemicircleProgressBar = ()=> import('./SemicircleProgressBar.vue')
import { getDeviceType } from '../../../util/deviceType'
import { getLoopDetails } from '../../../api/power'
import { subscribe,subscribeByNodes } from '../../../mqtt/index'

export default {
    props:['transformer'],
    data(){
        return {
            options:{
                positiveColor:'#5AD8A6',
            },
            value:'0.3', // 进度条
            lvsLoop:'', //低压侧回路
            hvsLoop:'',//高压侧回路
            heightArr:[
                {
                    id:1,
                    con:'A相电压',
                    unit:' kV',
                    unit1:' V',
                    value:'/Ua',
                    multiple:1
                },
                {
                    id:3,
                    con:'B相电压',
                    unit:' kV',
                    unit1:' V',
                    value:'/Ub',
                    multiple:1
                },
                {
                    id:5,
                    con:'C相电压',
                    unit:' kV',
                    unit1:' V',
                    value:'/Uc',
                    multiple:1
                },
                {
                    id:7,
                    con:'A相电流',
                    unit:' A',
                    unit1:' A',
                    value:'/Ia',
                    multiple:1
                },
                {
                    id:9,
                    con:'B相电流',
                    unit:' A',
                    unit1:' A',
                    value:'/Ib',
                    multiple:1
                },
                {
                    id:11,
                    con:'C相电流',
                    unit:' A',
                    unit1:' A',
                    value:'/Ic',
                    multiple:1
                },
            ],
            lowArr:[
                {
                    id:1,
                    con:'A相电压',
                    unit:' kV',
                    unit1:' V',
                    value:'/Ua',
                    multiple:1
                },
                {
                    id:2,
                    con:'AB线电压',
                    unit:' kV',
                    unit1:' V',
                    value:'/Uab',
                    multiple:1
                },
                {
                    id:3,
                    con:'B相电压',
                    unit:' kV',
                    unit1:' V',
                    value:'/Ub',
                    multiple:1
                },
                {
                    id:4,
                    con:'BC线电压',
                    unit:' kV',
                    unit1:' V',
                    value:'/Ubc',
                    multiple:1
                },
                {
                    id:5,
                    con:'C相电压',
                    unit:' kV',
                    unit1:' V',
                    value:'/Uc',
                    multiple:1
                },
                {
                    id:6,
                    con:'AC线电压',
                    unit:' kV',
                    unit1:' V',
                    value:'/Uac',
                    multiple:1
                },
                {
                    id:7,
                    con:'A相电流',
                    unit:' A',
                    unit1:' A',
                    value:'/Ia',
                    multiple:1
                },
                {
                    id:8,
                    con:'有功功率',
                    unit:' kW',
                    unit1:' kW',
                    value:'/P',
                    multiple:1000
                },
                {
                    id:9,
                    con:'B相电流',
                    unit:' A',
                    unit1:' A',
                    value:'/Ib',
                    multiple:1
                },
                {
                    id:10,
                    con:'无功功率',
                    unit:' kVar',
                    unit1:' kVar',
                    value:'/PR',
                    multiple:1000
                },
                {
                    id:11,
                    con:'C相电流',
                    unit:' A',
                    unit1:' A',
                    value:'/Ic',
                    multiple:1
                },
                {
                    id:12,
                    con:'视在功率',
                    unit:' kVA',
                    unit1:' kVA',
                    value:'/PA',
                    multiple:1000
                },{
                    id:13,
                    con:'功率因数',
                    unit:'',
                    unit1:'',
                    value:'/PF',
                    multiple:1
                },
                {
                    id:14,
                    con:'频率',
                    unit:' Hz',
                    unit1:' Hz',
                    value:'/F',
                    multiple:1
                },
            ]
        }
    },
    components:{
        SemicircleProgressBar
    },
    watch:{
        'transformer.loop_id'(val){
            console.log(this.transformer);
            this.getLoop(this.transformer)
            
        }
    },
    computed:{
		mqttval() {
			return this.getMqttVal(this.$store.getters.mqttVal);
		},
        transformerLoad(){
            let load = ''
            // if(this.$store.getters.projectId==1){
            //     let la = this.mqttval(this.transformer.subLoopUrl +'/Ia')
            //     let Ib = this.mqttval(this.transformer.subLoopUrl +'/Ib')
            //     let Ic = this.mqttval(this.transformer.subLoopUrl +'/Ic')

            //     let a = la == '--'?0:Number(la)
            //     let b = Ib == '--'?0:Number(Ib)
            //     let c = Ic == '--'?0:Number(Ic)
            //     let zong = la == '--' &&  Ib == '--' && Ic == '--'?'--': a + b + c;
            //     let v = zong == '--'?'--': zong/3/(parseFloat(JSON.parse(this.transformer.device_details)['电气']['容量'])*1000/400/Math.sqrt(3))*100;
            //     load = v=='--'?'--': v.toFixed(2)
            // }else{
                if(this.$store.getters.projectId==19){
                    load = this.mqttval(this.transformer.subLoopUrl + '/PA') == '--'?'--': Number(Math.abs(this.mqttval(this.transformer.subLoopUrl + '/PA'))  / 10 / parseFloat(JSON.parse(this.transformer.device_details)['电气']['容量'])).toFixed(2)
                }else{
                    load = this.mqttval(this.transformer.subLoopUrl + '/P') == '--'?'--': Number(Math.abs(this.mqttval(this.transformer.subLoopUrl + '/P'))  / 10 / parseFloat(JSON.parse(this.transformer.device_details)['电气']['容量'])).toFixed(2)
                }
                
            // }
            return load
        }
    },
    mounted(){
        console.log(this.transformer);
        if(this.transformer){
            this.getLoop(this.transformer)
        }
    },
    methods:{
        getMqttVal(f) {
			return (k, m) => {
				if (k) {
				let mqttVal = f(k);
				if (m) {
					mqttVal *= m;
				}
				mqttVal = Number(mqttVal).toFixed(2);
				if (typeof mqttVal === "object") {
					return mqttVal;
				}
				return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
				} else {
				return "--";
				}
			};
		},
        async getLoop(transformer){
            let res = await getLoopDetails({
                deviceLoopId:transformer.transformer_hvs
            })
            let res2 = await getLoopDetails({
                deviceLoopId:transformer.transformer_lvs
            })
            // console.log(res);
            // console.log(res2);
            if(res.data.code == 200){
                if(Object.keys(res.data.data) == 0 ){
                    console.log('没有高压回路');
                }else{
                    this.hvsLoop = res.data.data.deviceLoop.subLoopUrl 
                }
                
            }else {
                console.log('err:' + res.data.errMsg);
            }

            if(res2.data.code == 200){
                if(Object.keys(res2.data.data) == 0 ){
                    console.log('没有低压回路');
                }else{
                    this.lvsLoop = res2.data.data.deviceLoop.subLoopUrl 
                }
                
            }else {
                console.log('err:' + res2.data.errMsg);
            }
            
            subscribe([this.lvsLoop, this.hvsLoop])
        }
    }
}
</script>

<style lang="less" scoped>
.transformerView{
    width: 100%;
    
    .title{
        font-size: 18rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        padding-bottom: 0.6vh;
        border-bottom:1px solid rgba(0, 0, 0, 0.15) ;
        padding-left: 0.7vw;
        position: relative;
        &::before{
            content:'';
            width: 0.3vw;
            height: 2vh;
            background-color: #0D94FF;
            position: absolute;
            top: 40%;
            left: 0;
            transform: translate(0, -50%);
        }
    }
    .overview{
        height: 16vh;
        box-sizing: border-box;
        padding: 1vh 0;
        display: flex;
        justify-content: space-between;

        .message{
            width:27% ;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            &>h1{
                font-size: 24rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
            }
            &>p{
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #666666;
            }
        }

        .load{
            width: 18%;
            padding: 20rem;
            height: 100%;
            background: rgba(0,43,102, 0.04);
            border-radius:5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            .valNumber{
                position: absolute;
                top: 65%;
                left: 50%;
                transform: translate(-50%, -50%);
                &>p{
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    padding: 0.1vh 0;
                    text-align: center;
                }
                &>p:nth-child(1){
                    font-size: 20rem;
                    color: #5AD8A6;
                    
                    white-space: nowrap;
                }
                &>p:nth-child(2){
                    font-size: 18rem;
                    color: #333333;
                }
            }
        }

        .loadcap{
            width: 50%;
            height: 100%;
            background: rgba(0,43,102, 0.04);
            border-radius:5rem;
            display: flex;
            .realtime{
                width: 50%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                &>p{
                    padding: 1vh 0;
                }
                &>p:nth-child(1){
                    font-size: 18rem;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #333333;
                }
                &>p:nth-child(2){
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #0D94FF;
                    &>span{
                        font-size: 20rem;
                    }
                }
            }
            .realtime:nth-child(2){
                &>p:nth-child(2){
                    color: #333333;
                }
            }
        }
    }

    .transformerEnty{
        height: 28vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .enty{
            width:31% ;
            height: 100%;
            background: url('../.././../assets/img/transformer.png') no-repeat;
            background-size: 90% 80%;
            background-position: 50% 80%;
            border: 1px solid #E5E5E5;
            box-shadow: 0px 0px 16px 0px rgba(0,43,102,0.08);
            position: relative;
            .temperature{
                width: 100%;
                padding: 0 0.2vw;
                position: absolute;
                top: 7%;
                left: 0;
                display: flex;
                justify-content: space-evenly;
                .temItem{
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                    scale: 0.8;
                    &>span{
                        display: inline-block;
                        font-family: Source Han Sans CN;
                        // -webkit-text-stroke: 0.2rem #FFFFFF;
                        font-weight: bold;
                    }
                    &>span:nth-child(1){
                        width: 15rem;
                        height: 15rem;
                        background:  #F6BD16;
                        border: 2px solid #FFFFFF;
                        border-radius: 50%;
                        margin-right: 3rem;
                    }
                    &>span:nth-child(2){
                        font-size: 14rem;
                        color: #333333;
                    }
                    &>span:nth-child(3){
                        font-size: 18rem;
                        color: #0D94FF;
                        &>i{
                            color: #0D94FF;
                        }
                    }
                }
                .temItem:nth-child(2){
                    &>span:nth-child(1){
                        background: #5AD8A6;
                    }
                }
                .temItem:nth-child(3){
                    &>span:nth-child(1){
                        background: #E8684A;
                    }
                }
            }

            .fan{
                width: 40rem ;
                height: 40rem;
                position: absolute;
                left: 50%;
                top: 65%;
                transform: translate(-50% , 0);
                &>img{
                    width: 100%;
                    height: 100%;
                }
                .transtion{
                    animation:transtion 2s linear infinite; 
                }
                .status{
                    position: absolute;
                    top: 107%;
                    left: 50%;
                    transform:translate(-50%, 0%) ;
                    white-space: nowrap;
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #000;
                    text-shadow: -1px 1px 0 #fff, 1px 1px 0 #fff, 1px -1px 0 #fff, -1px -1px 0 #fff;
                    &>span{
                        font-size: 18rem;
                        color: #0D94FF;
                    }
                }
            }

        }
        .heightLow{
            width: 43%;
            height: 100%;

            .tab{
                width: 100%;
                height: 12.5%;
                display: flex;
                align-items: center;

                &>span{
                    display: inline-block;
                    margin: 0 15rem;
                    position: relative;
                    color: #333;
                    font-size:18rem ;
                    font-weight: bold;
                    &::before{
                        content:'';
                        width: 100%;
                        height: 3rem;
                        background-color: none;
                        border-radius: 1.5rem;
                        position: absolute;
                        top: 110%;
                        left: 0;
                    }
                }
                .se{
                    color:#0D94FF ;
                    &::before{
                        content:'';
                        background-color: #0D94FF;
                    }
                }
            }
            .box{
                height: calc(100% - 12.5%);
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                border-top:1px solid rgba(0, 0, 0, 0.15) ;
                .boxItem{
                    width: 50%;
                    height: 14.25%;
                    display: flex;
                    .val{
                        width: 50%;
                        height: 100%;
                        background:#F5F7F9 ;
                        position: relative;
                        font-size: 16rem;
                        white-space: nowrap;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                        &>span{
                            position: absolute;
                            left: 20%;
                            top: 50%;
                            transform: translate(0, -50%);
                            &>i{
                                font-size: 14rem;
                            }
                        }
                    }
                    .val:nth-child(2){
                        background:#fff ;
                        color: #0D94FF;
                        font-size: 18rem;
                        &>span{
                            position: absolute;
                            left: 5%;
                            top: 50%;
                            transform: translate(0, -50%);
                            &>i{
                                font-size: 12rem;
                            }
                        }
                    }
                }
                .boxItem:nth-child(odd){
                    border-left: 1px solid rgba(0, 0, 0, 0.15);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    border-right: 1px solid rgba(0, 0, 0, 0.15);
                }
                .boxItem:nth-child(even){
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    border-right: 1px solid rgba(0, 0, 0, 0.15);
                }
            }
        }

        .heightLow1{
            width: 21%;
            .box{
                flex-direction: column;
                .boxItem{
                    width: 100%;
                }
                .boxItem:nth-child(even){
                    border-left: 1px solid rgba(0, 0, 0, 0.15);
                }
            }
        }

    }
}
    @keyframes transtion{
		0%{
			transform:rotateZ(0deg);
		} 
		100%{
			transform:rotateZ(-360deg);
		}
	}
</style>